"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var createIcon_1 = __importDefault(require("../createIcon"));
var BrandIconPolicy = function (props) {
    return (react_1.default.createElement(createIcon_1.default, __assign({ role: "img", ariaLabel: "Policy" }, props),
        react_1.default.createElement("title", null, "Policy"),
        react_1.default.createElement("path", { d: "M17.143 111.431H60V8.574H17.143V111.43z", fill: "#D44513" }),
        react_1.default.createElement("path", { d: "M102.857 31.425v80.004H60V8.572h20.004l22.853 22.853z", fill: "#FF6E00" }),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M92.143 98.571H27.857V90h64.286v8.571zM92.143 77.143H27.857v-8.572h64.286v8.572zM92.143 55.715H27.857v-8.572h64.286v8.572z", fill: "#000" }),
        react_1.default.createElement("path", { d: "M102.857 31.425H80.004V8.572l22.853 22.853z", fill: "#007562" })));
};
exports.default = BrandIconPolicy;
